import React, { useEffect, useState } from "react";
import "./ContactUs.scss";
import causalfunnel_fullLogo from "../../assets/images/mains/CausalFunnelFullLogo.svg";
import emailSuccess from "../../assets/images/icons/email.gif";
import StartTrialBtn from "../Home/StartTrialBtn"
import { dataUpdateInDB, emialSend} from './Helper'

const ContactForm = ({ title, desc, btnText, url }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [subject, setSubject] = useState("Start Free Trial");
  const [message, setMessage] = useState(
    "Hello, I would like to start my free trial to see how CausalFunnel can help me."
  );
  const [formState, setFormValues] = useState({});
  const [formSubmit, setFormSubmit] = useState(false);

  useEffect(() => {
    if (url === '/contact-us') {
      setSubject('');
      setMessage('');
    } else if (url === '/free-trial') {
      setSubject('Start Free Trial');
      setMessage('Hello, I would like to start my free trial to see how CausalFunnel can help me.');
    }
  }, [url])
  const contactFormHandler = (e) => {
    e.preventDefault();
    const submittedFormData = { name, email, mobile, subject, message };
    setFormValues(submittedFormData);
    console.log("User Submitted Data", submittedFormData);
    dataUpdateInDB(submittedFormData)
    emialSend(submittedFormData)
    setFormSubmit(true);
  };

  return (
    <div className="contactForm-container container-lg">
      <div className="contactForm-text">
        <h2 className="section-title" x-intersect="$el.classList.add('fadeInUp-parallax')">{title} </h2>
        <p className="text-center" x-intersect="$el.classList.add('fadeInUp-parallax')">
          {" "}
          {desc}
        </p>
      </div>
      {formSubmit ? (
        <div className="formSubmit-Msg-Container">
          <div className="success-form-container p-1 p-md-4 my-5 flex-col">
            <div className="success-body">
              <div className="cf-logo px-2">
                <img
                  className="logo"
                  src={causalfunnel_fullLogo}
                  alt="CausalFunnel Logo"
                />
              </div>

              <div className="success-msg">
                <img
                  className="success-logo"
                  src={emailSuccess}
                  alt="CausalFunnel Logo"
                />
                <h2 className="section-title">Thank You</h2>
                <h5>We have received your message.</h5>
              </div>
            </div>
            <div className="text-center my-4">
              <StartTrialBtn title="Back To Home" href="/"/>
            </div>
          </div>
        </div>
      ) : (
        <div className="contactform-container pt-5" x-intersect="$el.classList.add('fadeInUp-parallax')">
          <form role="form" className="mt-1" onSubmit={contactFormHandler}>
            <div className="form-content flex-col">
              <div className=" full-width py-1 flex">
                <div className="form-group equally-grow ">
                  <input
                    type="text"
                    placeholder=" Name *"
                    className="form-control input-underline "
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group equally-grow ">
                  <input
                    type="email"
                    placeholder=" Email *"
                    className="form-control input-underline"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
              </div>
              <div className=" full-width py-1 flex">
                <div className="form-group equally-grow">
                  <input
                    type="tel"
                    placeholder=" Mobile *"
                    className="form-control input-underline"
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group equally-grow ">
                  <input
                    type="text"
                    placeholder=" Subject "
                    className="form-control input-underline"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                  />
                </div>
              </div>
              <div className="form-group full-width py-1">
                <textarea
                  placeholder=" Message "
                  className="form-control input-underline textAreaBorder"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
              </div>
            </div>
            <div className="text-center my-4">
              <button
                type="submit"
                className="startTrial-button"
                style={{ cursor: "pointer" }}
              >
                {btnText}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default ContactForm;
